module.exports = __webpack_public_path__ + "img/lara_loureiro.a61f3c8f.jpeg";